import { PlusIcon } from "lucide-react";

import type { RouterOutputs } from "@blis/trpc/react";

import { buttonVariants } from "@/components/ui/button";
import { Link } from "@/components/ui/link";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

type Printer = RouterOutputs["printers"]["list"][number];

export function PrintersTable({
  printers,
}: {
  printers: Printer[] | undefined;
}) {
  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "printers",
    printers,
    [
      {
        field: "name",
        headerName: "Name",
        cellRenderer: (params) => (
          <Link
            href={{
              to: "/admin/printers/$id/edit",
              params: { id: params.id as string },
            }}
          >
            {params.name}
          </Link>
        ),
        cellRendererParams: (params) => ({
          name: params.data.name,
          id: params.data.id,
        }),
      },
      {
        field: "type",
        headerName: "Type",
        filter: "agSetColumnFilter",
        valueFormatter: (params) =>
          params.value === "NETWORK" ? "Network" : "USB",
      },
      {
        field: "address",
        headerName: "Address",
        valueFormatter: (params) => {
          const data = params.data as Printer;
          if (data.type === "NETWORK") {
            return `${data.address ?? ""}:${data.port ?? 9100}`;
          }
          return data.usbVendorId
            ? `${data.usbVendorId}:${data.usbProductId}`
            : "";
        },
      },
      {
        field: "label",
        headerName: "Lab label",
        filter: "agSetColumnFilter",
      },
      {
        field: "enabled",
        headerName: "Enabled",
        valueFormatter: (params) => (params.value ? "Yes" : "No"),
        filter: "agSetColumnFilter",
      },
    ],
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link href={{ to: "/admin/printers/new" }} className={buttonVariants()}>
          <PlusIcon data-slot="icon" />
          Add printer
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
